module.exports = __webpack_public_path__ + "static/img/kr.121e382.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/img/footer_icon/hover/kr.png
// module id = HSKq
// module chunks = 0